import React from "react";
import VideoOptimizedClean from "./VideoOptimizedClean";
import type {VideoProps} from "./VideoOptimizedClean";

// Simple SSR wrapper - Resource hints handled by Gatsby's Head API
const VideoWithSSRClean = (props: VideoProps) => {
  return <VideoOptimizedClean {...props} />;
};

export default VideoWithSSRClean;
export type {VideoProps} from "./VideoOptimizedClean";
export {VideoType} from "./VideoOptimizedClean";
